exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{margin:0}#app{padding:10px}.selection .selection-dialog{position:absolute;z-index:10;top:0;bottom:0;left:0;right:0}.selection table{background:#2d3241;border-collapse:collapse;margin-top:43px;margin-left:10px}.selection table tr td{border:2px solid #364450}.selection table tr td a{cursor:pointer}.selection table tr td img{width:60px;height:60px}.orgchart-container{height:auto;width:auto;min-width:100%;border:none}.orgchart{background-image:none}.orgchart .node{width:auto}.nodedata{background-color:#4a5c72;padding:5px;display:flex}.nodedata img{width:60px;height:60px;display:block}.nodedata p{margin:0;line-height:20px;font-size:14px;color:#fff}.nodedata>div{width:50%;flex:1}.nodedata>div.nodedata-left{border-right:1px dashed #999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e7dd6b0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 89
// module chunks = 0